function getItem(itemName: string): string {
  try {
    return localStorage?.getItem(itemName)
  } catch (error) {
    return null
  }
}

function setItem(itemName: string, item: object): void {
  try {
    localStorage?.setItem(itemName, JSON.stringify(item))
  } catch (_) {}
}

function removeItem(itemName: string): void {
  try {
    localStorage?.removeItem(itemName)
  } catch (_) {}
}

function removeItems(itemNames: string[]): void {
  try {
    itemNames.forEach(itemName => localStorage?.removeItem(itemName))
  } catch (_) {}
}

export default {
  getItem,
  setItem,
  removeItem,
  removeItems
}

/**
 * Creates a mock storage object for testing purposes
 * @param {Record<string, string>} [initialEntries={}] Initial entries to populate the storage with
 * @returns {Storage}
 */
export function createStorageMock(initialEntries: Record<string, string> = {}): Storage {
  const storage = new Map<string, string>(Object.entries(initialEntries))

  return {
    get length(): number {
      return storage.size
    },
    clear(): void {
      storage.clear()
    },
    getItem(key: string): string | null {
      return storage.get(key) ?? null
    },
    key(index: number): string | null {
      return Array.from(storage.keys())[index] ?? null
    },
    removeItem(key: string): void {
      storage.delete(key)
    },
    setItem(key: string, value: string): void {
      storage.set(key, value)
    }
  }
}
